import actions from "./actions";

let idx, items, item;

const initState = {
    items: [],
    editLine: null,
    focusedElement: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.INVENTORY_SET_EDIT_LINE:
            return {
                ...state,
                editLine: action.line,
            };
        case actions.INVENTORY_EDIT_PREV_LINE: {
            idx = state.items.findIndex(item => item.line === state.editLine); // current line.
            const editLine = (
                (idx !== -1 && state.items[idx - 1]) ?
                    state.items[idx - 1].line :
                    state.editLine
            );

            return {
                ...state,
                editLine,
            };
        }
        case actions.INVENTORY_EDIT_NEXT_LINE: {
            idx = state.items.findIndex(item => item.line === state.editLine); // current line.
            const editLine = (
                (idx !== -1 && state.items[idx + 1]) ?
                    state.items[idx + 1].line :
                    state.editLine
            );

            return {
                ...state,
                editLine,
            };
        }
        case actions.INVENTORY_SET_FOCUSED_ELEMENT:
            return {
                ...state,
                focusedElement: action.element,
            };
        case actions.INVENTORY_SET_ITEMS:
            return {
                ...state,
                items: action.items,
            };
        case actions.INVENTORY_SET_ITEM: // Support partial update (Must have line)
            items = [...state.items];

            // Merge the item
            idx = items.findIndex(item => item.line === action.item.line);
            item = {
                ...items[idx],
                ...action.item,
            };

            // Merge back to items
            items[idx] = item;

            return {
                ...state,
                items,
            };
        case actions.INVENTORY_ADD_ITEM: { // Add to the end of the list
            const item = {...action.item};
            item.line = parseInt(Math.random() * 1000000000, 10); // Random
            item.key = item.line.toString();

            return {
                ...state,
                items: [
                    ...state.items,
                    item,
                ],
                editLine: action.editItem ? item.line : state.editLine,
            };
        }
        case actions.INVENTORY_ADD_ITEMS: { // Add to the end of the list
            const items = action.items.map(item => ({
                ...item,
                line: parseInt(Math.random() * 1000000000, 10), // Random
                key: item.line.toString(),
            }));

            return {
                ...state,
                items: [
                    ...state.items,
                    ...items,
                ],
            };
        }
        case actions.INVENTORY_REMOVE_ITEM: // Delete from the list
            items = [...state.items];
            idx = items.findIndex(item => item.line === action.line);
            items.splice(idx, 1);

            return {
                ...state,
                items,
                editLine: action.line === state.editLine ? null : state.editLine,
            };
        default:
            return state;
    }
}
